export default "__VITE_ASSET__B2O_hhCi__"